export default "__VITE_ASSET__Dn594t5Z__"